import { Injectable } from '@angular/core';
import KeyStore  from "../key-store";
import  PrivateKey  from "../private-key";

@Injectable({
  providedIn: 'root'
})
export class KeyStoreService {
  private ks = new KeyStore();
  keys = [];
  i = 0;
  private pk;
  private currentKey = null;
  private agent;
  constructor() { 
  } 
  async usePK () {
    if(!this.keys.length) {
        this.keys = this.ks.read();
    }
    return this.keys.length > 0;
  }
  async reset () {
    let ext = document.getElementById('fastx@starnet.com');

    this.agent = Boolean(ext?.dataset?.enabled);

    this.ks =  new KeyStore ();
    this.keys = await this.ks.read (); 
    this.i = 0;
    this.currentKey = null;
    return this.keys;
  }
  decrypt (passphrase = '') {
    let c = this.current ();
    if(!c)
        throw new Error("No key");
    return PrivateKey.decryptKey(c.key, passphrase);
  }
  getKey(passphrase = '') {
    if(passphrase) {
        return this.decrypt(passphrase);
    }
    return PrivateKey.factory(this.current()?.key || '');

  }
  isEncrypted () {
    let c = this.current();
    return c ? PrivateKey.isEncrypted(c.key) : false;
   
  }
  current () {
    return this.keys.length <= this.i ? null : this.keys [this.i];
  }
  start() {
    this.i = -1;
    return this.next();
  }
  hasNext() {
    return this.keys.length ? this.keys.length > this.i + 1 : false;
  }
  next () {
    // cycle through bad keys
        this.keys.length <= this.i ? null : this.keys [++this.i];        
  }
}
